import { Theme } from '@mui/material';
import { DraggableStateSnapshot, DraggingStyle, NotDraggingStyle } from 'react-beautiful-dnd';

/**
 * used to over-ride the styles on drag and drop event
 * @param style - applied drag and drop styles
 * @param snapshot - snapshot of current drag status
 * @example - getStyle
 */
export const getStyle = (
  snapshot: DraggableStateSnapshot,
  style: DraggingStyle | NotDraggingStyle | undefined,
  theme: Theme
) => {
  if (!snapshot.isDropAnimating) {
    return {
      ...style,
      backgroundColor: snapshot.isDragging ? `${theme?.palette?.background?.main}` : 'inherit',
      cursor: 'pointer',
    };
  }
  return {
    ...style,
    transitionDuration: '0.01s',
  };
};
